export default {
  topicCard: 'group cursor-pointer rounded-lg border py-7 px-6 flex flex-col justify-center items-center hover:bg-[#00518B] hover:border-color-white w-[49%] sm:w-[24%]',
  topicTitle: 'text-center mt-2 font-base text-[#C7E5FB] font-interMedium group-hover:text-color-white',
  childCard: 'mt-6 group cursor-pointer rounded-lg border py-3 px-5 flex flex-col justify-center items-center text-color-white hover:bg-[#00518B] hover:border-color-white',
};
